/* eslint-disable max-len */
export default (element) => {
  const headerSearch = document.querySelector('[data-header-search]');
  const searchButton = document.querySelector('[data-header-search]~button');
  const closeButton = element.querySelector('[data-search-modal-close]');
  const searchModalInput = element.querySelector('[data-search-modal-input]');
  const searchResultsContainer = element.querySelector('[data-search-modal-predictive-result]');
  const searchSuggestionsContainer = element.querySelector('[data-search-suggestions]');
  const searchProductsContainer = element.querySelector('[data-search-results]');
  const isB2B = document.querySelector('[data-b2b="true"');
  const initialResults = document.querySelector('[data-search-modal-initial-result]');

  function debounce(func, wait, immediate) {
    let timeout;
    return (...args) => {  
      const context = this; 
      const later = () => {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

	const fetchPredictiveSearchResults = async (query) => {
    const response = await fetch(
      `/search/suggest.json?q=${
        encodeURIComponent(query)
      }&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last`);
    const data = await response.json();
    return data.resources.results.products || [];
  };

  const displayPredictiveResults = (products) => {
    if (!products.length) {
      searchResultsContainer.classList.add('hidden');
      return;
    }
    const suggestionsHtml = products.map(product => `
      <li><a href="${product.url}" class="cta--primary font-bold">
      ${product.title}
      </a></li>
    `).join('');
  
    const productsHtml = products.map(product => `
      <a class="flex flex-col no-underline text-primary" href="${product.url}">
        <img src="${product.image}" alt="${product.title}" class="w-full">
        <p class="utility-2-bold pt-2">${product.title}</p>
        <p class="utility-2">${product.price}</p>
      </a>
    `).join('');
  
    searchSuggestionsContainer.innerHTML = suggestionsHtml;
    searchProductsContainer.innerHTML = productsHtml;
  
    // Check if the View All button already exists
    let viewAllButton = searchResultsContainer.querySelector('.view-all-button');
    if (!viewAllButton) {
      // Create the View All button if it doesn't exist
      viewAllButton = document.createElement('div');
      viewAllButton.className = 'flex justify-center items-center mt-4 view-all-button';
      const buttonLink = document.createElement('a');
      buttonLink.className = 'button button--primary-outline no-underline'; 
      buttonLink.textContent = 'View All';
      viewAllButton.appendChild(buttonLink);
      searchResultsContainer.appendChild(viewAllButton);
    }
  
    // Update the href of the View All button
    viewAllButton.querySelector('a').href = `/search?q=${
      encodeURIComponent(searchModalInput.value.trim())
    }`;
  
    searchResultsContainer.classList.remove('hidden');
  };

	const openSearch = () => {
		element.classList.remove('hidden');
		element.classList.add('flex');
		initialResults.classList.add('!flex');
		searchModalInput.focus();
	}

	const closeSearch = () => {
		element.classList.add('hidden');
	}
	
	const setupEnterKeyRedirection = (event) => {
		if (event.key === 'Enter') {
			event.preventDefault(); 
			const query = searchModalInput.value.trim();
			if (query) {
				window.location.href = `/search?q=${encodeURIComponent(query)}`; 
			}
		}
	}

	if (isB2B) {
		initialResults.classList.remove('!hidden');

		const handleSearch = debounce(async () => {
			const query = searchModalInput.value.trim();
			if (query.length > 0) {
				const products = await fetchPredictiveSearchResults(query);
				displayPredictiveResults(products);
				initialResults.classList.remove('!flex');
			} else {
				searchResultsContainer.classList.add('hidden');
				initialResults.classList.add('!flex');
			}
		}, 300); // Adjust delay as needed, 300ms is generally a good balance
	
		searchModalInput.addEventListener('input', handleSearch);
		searchModalInput.addEventListener('keydown', (event) => setupEnterKeyRedirection(event));
	}
	
	searchButton.addEventListener('click', openSearch);	
	headerSearch.addEventListener('click', openSearch);	
	closeButton.addEventListener('click', closeSearch);
	element.addEventListener('click', (e) => {
		if (e.target !== e.currentTarget) return;
		closeSearch()
	});
};
